import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer
class ThreeDotMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuOpen: false,
        }
    }

    toggleMenuOpen = (e) => {
        e.stopPropagation()
        const { menuOpen } = this.state

        if (!menuOpen) document.body.addEventListener('click', this.toggleMenuOpen)
        if (menuOpen) document.body.removeEventListener('click', this.toggleMenuOpen)
        this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }))
    }

    render() {
        const { menuOpen } = this.state
        const { menuOptions } = this.props
        return (
            <div
                className="menu"
            >
                <div
                    onClick={this.toggleMenuOpen}
                    className="menu-icon"
                    style={{
                        backgroundColor: menuOpen ? '#EDF1F7' : undefined,
                    }}
                >
                    <i className="fa-regular fa-ellipsis-vertical" />
                </div>
                <div
                    className="menu-container"
                    style={{
                        display: menuOpen ? 'block' : 'none',
                    }}
                >
                    <ul style={{
                        listStyleType: 'none',
                        fontSize: '13px',
                        cursor: 'pointer',
                        height: '100%',
                        position: 'relative',
                        padding: '0',
                    }}
                    >
                        {menuOptions}
                    </ul>
                </div>
            </div>
        )
    }
}

export default ThreeDotMenu
